import BaseAPIService from '../base/base-api-service';
import MonthlyStatementModel from 'src/model/monthlyStatement.model';
import { downloadFile } from 'src/utils/downloadHelper';
import LocaleFormating from 'src/translation/localeFormating';
import env from 'src/shared/env';
import { number } from 'prop-types';

class MonthlyStatementService extends BaseAPIService<MonthlyStatementModel> {
  public baseURL: string = env.REACT_APP_BASE_API_URL;
  public endpoint: string = 'accountapp/v1/monthlyStatement';

  constructor() {
    super(MonthlyStatementModel);
  }

  public getMonthlyStatements(
    page: number,
    period: number,
    size: number
  ): Promise<MonthlyStatementModel> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'GET',
      params: {
        page,
        period,
        size
      },
      url: `${this.endpoint}`
    })
      .then(res => {
        return res.data;
      })
      .catch(error => {
        throw error;
      });
  }

  public downloadStatement(period: number) {
    return new Promise((resolve, reject) => {
      const downloadStatementsEndpoint = `${this.baseURL}accountapp/v1/monthlyStatement/download`;
      this.doRequest({
        method: 'get',
        url: downloadStatementsEndpoint,
        responseType: 'blob',
        params: {
          period
        }
      })
        .then((response: any) => {
          if (response.status === 200) {
            resolve(response);
          } else if (response.status === 204) {
            reject('No statements');
          } else {
            reject();
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }
}

const MonthlyStatementServiceInstance = new MonthlyStatementService();
Object.freeze(MonthlyStatementServiceInstance);

export default MonthlyStatementServiceInstance;
